module.exports = __webpack_public_path__ + "media/images/icon_pin-79e04b07bcaa1266eee3164e83f574b4.png";